import type { TranslationsBase } from './ko';

const id: TranslationsBase = {
  lang: 'id',
  langName: 'Bahasa Indonesia',
  flag: '🇮🇩',

  siteTitle: 'Latihan Soal TOEFL Online Gratis — Analisis AI | Power TOEFL 2026',
  siteDescription: 'Latihan soal TOEFL iBT gratis 3.500+ soal. Analisis kelemahan AI, catatan salah otomatis, tabel konversi skor — platform belajar TOEFL 2026.',
  ogTitle: 'Latihan Soal TOEFL Online Gratis — Analisis AI | Power TOEFL 2026',

  navGrammar: 'Grammar',
  navPractice: 'Latihan per Part',
  navScoreChart: 'Tabel Skor',
  navVocabulary: 'Kosakata',
  navTips: 'Tips/Strategi',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'Berbicara',
  navWriting: 'Menulis',
  navQuestionPool: 'Bank Soal',
  navResources: 'Materi',

  loginButton: 'Masuk',
  wrongAnswers: 'Catatan Salah',
  logout: 'Logout',
  loginRequired: 'Catatan salah & lanjutkan memerlukan login.',
  googleLogin: 'Mulai dengan Google dan aktifkan fitur premium',

  heroBadge: 'Sistem Belajar TOEFL Premium',
  heroTitle1: 'Platform satu-satunya',
  heroTitle2: 'untuk skor TOEFL tinggi',
  heroDesc1: 'Dari simulasi 4 bagian format 2026 hingga catatan salah,',
  heroDesc2: 'membantu Anda mencapai target skor dengan sempurna.',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47 soal',
  lcTime: '29 menit',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50 soal',
  rcTime: '30 menit',
  startTest: 'Mulai Tes',
  fullTestStart: 'Mulai Tes Lengkap (Reading → Listening)',
  fullTestDesc: 'Kerjakan dua bagian secara berurutan',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: 'Alat Belajar Lainnya',
  practiceLabel: 'Latihan per Part',
  practiceDesc: 'Belajar Reading·Listening terpisah',
  scoreChartLabel: 'Tabel Konversi Skor',
  scoreChartDesc: 'Jawaban benar → Skor konversi',
  vocabLabel: 'Kosakata',
  vocabDesc: 'Kosakata wajib TOEFL',
  tipsLabel: 'Tips/Strategi',
  tipsDesc: 'Strategi Listening·Reading',
  catLabel: 'CAT Adaptif',
  catDesc: 'Tingkat kesulitan otomatis',
  fullTestCardLabel: 'Full Test Simulasi',
  fullTestCardDesc: 'Reading + Listening simulasi',

  statQuestions: 'soal',
  statParts: 'part',
  statMinutes: 'menit',

  footerMockTest: 'Latihan',
  footerQuestionPool: 'Bank Soal',
  footerPractice: 'Latihan per Section',
  footerStudy: 'Belajar',
  footerBooks: 'Buku Rekomendasi',
  footerEtc: 'Lainnya',
  footerLC: 'Latihan Listening',
  footerRC: 'Latihan Reading',
  footerSpeaking: 'Latihan Speaking',
  footerWriting: 'Latihan Writing',
  footerLCStrategy: 'Strategi Listening',
  footerRCStrategy: 'Strategi RC',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL® adalah merek dagang terdaftar ETS. Power TOEFL tidak berafiliasi dengan ETS dan dioperasikan secara independen.',

  faqTitle: '❓ Pertanyaan yang Sering Diajukan (FAQ)',
  faqDesc: 'Temukan jawaban tentang ujian TOEFL dan Power TOEFL.',
  faqPageTitle: 'Pendaftaran TOEFL · Perhitungan Skor · Masa Berlaku — FAQ 2026 | Power TOEFL',
  faqPageDesc: 'Cara mendaftar TOEFL, konversi skor, masa berlaku, strategi per part — 30 pertanyaan paling sering diajukan dalam satu halaman.',
  faqMore: 'Ada pertanyaan lain? Kami terus memperbarui FAQ.',

  scoreChartPageTitle: 'Tabel Skor TOEFL 2026 — Cara Hitung Skor dari Jawaban Benar | Power TOEFL',
  scoreChartPageDesc: 'Cara menghitung skor TOEFL dari jumlah jawaban benar. Masukkan jawaban benar LC·RC untuk estimasi skor + panduan belajar gratis per target skor.',
  scoreChartHeading: '📊 Tabel Skor TOEFL 2026',
  scoreChartIntro: 'Tabel bagian 0–30 dan total 0–120 adalah estimasi belajar Power TOEFL pada skala lama/sebanding. Laporan resmi 2026 mengutamakan skor bagian dan keseluruhan 1–6 dalam kenaikan 0,5.',
  scoreChartLC: 'Tabel Konversi LC (Listening)',
  scoreChartRC: 'Tabel Konversi RC (Reading)',
  scoreChartCorrect: 'Jawaban Benar',
  scoreChartConverted: 'Skor Konversi',
  scoreChartUnit: '',
  scoreChartPointUnit: 'poin',
  scoreGuideTitle: '🎯 Panduan Target Skor',
  scoreGuide900: 'Tertinggi',
  scoreGuide900Desc: 'Butuh LC 90+ / RC 90+ benar. Level hampir sempurna.',
  scoreGuide800: 'Atas',
  scoreGuide800Desc: 'Target LC 80+ / RC 80+ benar. Bahasa Inggris bisnis tingkat lanjut.',
  scoreGuide700: 'Menengah Atas',
  scoreGuide700Desc: 'Memenuhi syarat kebanyakan pekerjaan. Perlu belajar konsisten.',
  scoreGuide600: 'Menengah',
  scoreGuide600Desc: 'Dasar sudah terbentuk. Fokus Reading dan Listening.',
  scoreChartFaqTitle: '❓ FAQ Skor TOEFL',
  scoreChartCtaTitle: 'Cek Kemampuan Anda Sekarang',
  scoreChartCtaDesc: 'Coba simulasi gratis 200 soal untuk mengetahui perkiraan skor Anda.',

  vocabPageTitle: 'Kosakata TOEFL Wajib 600 Kata — Arti Bahasa Indonesia & Contoh Kalimat | Power TOEFL',
  vocabPageDesc: '600 kosakata TOEFL wajib dalam 6 kategori: bisnis, HR, pemasaran, keuangan, manufaktur, sehari-hari. Lengkap dengan arti dan contoh kalimat.',
  vocabHeading: '📚 Kosakata Wajib TOEFL',
  vocabIntro: 'Pelajari 600 kosakata TOEFL yang paling sering muncul. Klik untuk melihat arti dan contoh.',
  vocabShowAll: 'Tampilkan Semua',
  vocabHideAll: 'Sembunyikan Semua',
  vocabReset: 'Reset',
  vocabClickToReveal: 'Klik untuk melihat arti',
  vocabMotivation: 'Belajar berulang secara konsisten akan meningkatkan skor TOEFL! 🚀',
  vocabCatNaturalScience: 'Ilmu Alam',
  vocabCatSocialScience: 'Ilmu Sosial',
  vocabCatHumanities: 'Humaniora',
  vocabCatLifeScience: 'Ilmu Hayat',
  vocabCatTechnology: 'Teknologi/Teknik',
  vocabCatAcademicGeneral: 'Akademik Umum',
  vocabSynonyms: 'Sinonim',
  vocabAntonyms: 'Antonim',
  vocabMyWords: 'Kosakata Saya',
  vocabAddWord: 'Tambah Kata',
  vocabAddWordPlaceholder: 'Ketik kata bahasa Inggris',
  vocabMyWordsEmpty: 'Belum ada kata. Coba tambahkan di atas!',
  vocabDeleteWord: 'Hapus',
  vocabLookingUp: 'Mencari...',
  vocabQuizTitle: 'Kuis Kosakata',
  vocabQuizDesc: 'Uji sinonim dan antonim yang telah Anda pelajari!',
  vocabQuizMode_synonym: 'Sinonim',
  vocabQuizMode_antonym: 'Antonim',
  vocabQuizMode_mixed: 'Campuran',
  vocabQuizClose: 'Tutup',
  vocabQuizNoQuestions: 'Kategori ini tidak memiliki cukup soal.',
  vocabQuizBack: 'Kembali',
  vocabQuizResult: 'Hasil Kuis',
  vocabQuizExcellent: 'Luar biasa! 🎉',
  vocabQuizGood: 'Bagus! Latihan sedikit lagi akan sempurna!',
  vocabQuizKeepGoing: 'Terus semangat! 💪',
  vocabQuizRetry: 'Coba Lagi',
  vocabQuizFindSynonym: 'Pilih sinonim dari kata berikut',
  vocabQuizFindAntonym: 'Pilih antonim dari kata berikut',
  vocabQuizNext: 'Berikutnya',
  vocabQuizFinish: 'Lihat Hasil',
  vocabQuizStart: 'Mulai Kuis',

  tipsLCPageTitle: 'Tips TOEFL Listening — Cara Meningkatkan Skor LC Conversations·Lectures | Power TOEFL 2026',
  tipsLCPageDesc: 'Cara meningkatkan skor TOEFL Listening. Strategi Conversations·Lectures, teknik pre-reading, pola jebakan, dan latihan rutin untuk skor LC tinggi.',
  tipsLCHeading: '🎧 Tips Meningkatkan Skor TOEFL Listening',
  tipsLCIntro: 'Strategi kunci untuk setiap Part LC dan rutinitas latihan yang terbukti efektif.',
  tipsLCButton: 'Tips LC',
  tipsRCButton: 'Tips RC',
  tipsLCPractice: 'Latihan Soal LC',
  tipsLCPracticeDesc: 'Terapkan strategi yang sudah dipelajari dalam latihan soal.',
  tipsLCStartTest: 'Mulai Latihan LC',
  tipsRCPageTitle: 'Tips TOEFL Reading — Cara Mengatasi Waktu Kurang RC Reading | Power TOEFL 2026',
  tipsRCPageDesc: 'Cara mengatasi waktu kurang TOEFL Reading. Strategi manajemen waktu Reading, teknik skimming, tips double/triple passage.',
  tipsRCHeading: '📖 Tips Mengatasi Waktu Kurang TOEFL Reading',
  tipsRCIntro: 'Strategi manajemen waktu dan teknik menjawab cepat untuk setiap Part RC.',
  tipsRCPractice: 'Latihan Soal RC',
  tipsRCPracticeDesc: 'Terapkan strategi yang sudah dipelajari dalam latihan soal.',
  tipsRCStartTest: 'Mulai Latihan RC',

  practicePartMeta: {
    '1': { title: 'TOEFL Reading — Strategi Artikel Akademis 20 Soal | Power TOEFL', desc: 'Cara membaca efektif artikel akademis TOEFL Reading. Keyword scanning, inferensi, dan ringkasan.' },
    '2': { title: 'TOEFL Listening Conversations — Strategi Note-taking | Power TOEFL', desc: 'Strategi inti TOEFL Listening Conversations. Tujuan percakapan, inferensi sikap, teknik pencatatan.' },
    '3': { title: 'TOEFL Listening Lectures — Strategi 18 Soal | Power TOEFL', desc: 'Strategi TOEFL Listening Lectures. Topik kuliah, inferensi maksud profesor, analisis contoh untuk skor tinggi.' },
  } as Record<string, { title: string; desc: string }>,

  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading membaca artikel akademis (sekitar 700 kata) dan menjawab pertanyaan tentang topik, detail, inferensi, kosakata, dan ringkasan. 35 menit untuk 2 artikel, total 20 soal. Menangkap kalimat topik dan scanning keyword adalah kunci manajemen waktu.',
      commonTypes: ['Topik/Tujuan (What is the passage mainly about?)', 'Detail (According to the passage...)', 'Kosakata (The word X is closest in meaning to...)', 'Inferensi (What can be inferred?)', 'Sentence insertion (Insert text)', 'Ringkasan (Prose Summary — pilih 3 poin utama)'],
      strategy: ['Baca pertanyaan dulu, ingat 2-3 keyword lalu scan artikel', 'Fokus kalimat pertama tiap paragraf (topic sentence) — artikel TOEFL biasanya deduktif', 'Soal kosakata berdasarkan konteks, bukan arti kamus', 'Soal ringkasan pilih ide utama saja, bukan detail kecil'],
      recommendedFor: ['Pemula TOEFL — bangun kemampuan membaca akademis', 'Target Reading 20+ — strategi alokasi waktu wajib', 'Lemah di inferensi/ringkasan — latihan fokus per jenis'],
      faq: [
        { q: 'TOEFL Reading waktu kurang bagaimana?', a: 'Alokasi 17-18 menit per artikel. Soal sulit tandai dan lewati. Sisakan minimal 3 menit untuk soal ringkasan.' },
        { q: 'Soal kosakata tidak tahu artinya?', a: 'Tebak dari konteks. Kalimat sebelum dan sesudah blank adalah petunjuk. Artinya bisa berbeda dari kamus.' },
        { q: 'Soal ringkasan (Prose Summary) bagaimana?', a: 'Pilih 3 jawaban yang mewakili ide utama tiap paragraf. Jawaban yang hanya detail 1 paragraf adalah salah.' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversations mendengarkan percakapan kampus (profesor-mahasiswa, staf-mahasiswa), durasi 3-5 menit, menjawab 5 soal. Fokus menangkap tujuan percakapan, detail, dan sikap pembicara.',
      commonTypes: ['Tujuan percakapan (Why does the student visit the professor?)', 'Detail (What does the professor say about...?)', 'Sikap/Maksud (What is the student\'s attitude?)', 'Tindakan selanjutnya (What will the student probably do next?)'],
      strategy: ['Tangkap tujuan langsung dari pembukaan percakapan', 'Catat informasi kunci (nama, tanggal, syarat)', 'Perhatikan nada dan ekspresi emosi — petunjuk utama soal sikap', 'Fokus pada kesimpulan dan tindakan selanjutnya di akhir'],
      recommendedFor: ['TOEFL Listening di bawah 15 — mulai dari percakapan pendek', 'Ingin mulai dari tipe lebih mudah daripada Lectures', 'Perlu latihan teknik pencatatan'],
      faq: [
        { q: 'Conversations wajib mencatat?', a: 'Ya. TOEFL menampilkan soal setelah audio selesai, tanpa catatan akan kehilangan detail. Gunakan singkatan dan simbol untuk mencatat cepat.' },
        { q: 'Bagaimana mengenali sikap pembicara?', a: 'Nada (yakin/ragu), ekspresi emosi ("I\'m not sure about that", "That sounds great"), penekanan berulang adalah petunjuk utama.' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lectures mendengarkan kuliah universitas (5-7 menit) menjawab 6 soal. Mencakup biologi, sejarah, seni, geologi. Menangkap topik, inferensi maksud profesor, dan analisis tujuan contoh adalah kunci.',
      commonTypes: ['Topik kuliah (What is the lecture mainly about?)', 'Maksud profesor (Why does the professor mention X?)', 'Detail (According to the professor...)', 'Inferensi (What does the professor imply?)', 'Struktur kuliah (How does the professor organize the lecture?)'],
      strategy: ['1-2 menit pertama tangkap topik dan tujuan — jenis soal paling dasar', 'Selalu pikirkan mengapa profesor memberi contoh — inti "Why does the professor mention X?"', 'Ungkapan transisi (Now, let\'s move on to...) menandai sub-topik baru', 'Inferensi ironi, humor, dan pertanyaan retoris profesor'],
      recommendedFor: ['Target TOEFL Listening 20+ — Lectures menentukan skor', 'Kesulitan mendengarkan kuliah akademis', 'Ingin membangun sistem pencatatan'],
      faq: [
        { q: '"Why does the professor mention X?" bagaimana?', a: 'Profesor menyebutkan contoh/analogi/eksperimen biasanya untuk melengkapi atau membandingkan konsep sebelumnya. Cari tujuan di konteks sebelum penyebutan.' },
        { q: 'Tidak punya background knowledge di Lectures merugikan?', a: 'Tidak. TOEFL menyediakan semua informasi yang diperlukan dalam kuliah. Background knowledge membantu tapi konten kuliah cukup untuk menjawab semua soal.' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  practiceRelatedLinks: '📌 Konten Terkait',
  practiceOtherParts: 'Strategi Part Lain',
  practiceMockTestCTA: 'Latihan dengan Simulasi Tes',
  practiceTipsLink: 'Lihat Strategi per Part',
  practiceGrammarLink: 'Belajar Grammar',

  practiceNotFound: 'Part tidak ditemukan.',
  practiceQuestionType: 'Jenis Soal',
  practiceTips: '💡 Tips Strategi',
  practiceExamples: '📝 Contoh Soal',
  practiceIntro: '📋 Pengantar Part',
  practiceCommonTypes: '📊 Jenis Soal yang Sering Muncul',
  practiceStrategy: '🎯 Poin Strategi',
  practiceRecommendedFor: '👤 Direkomendasikan Untuk',
  practiceFAQ: '❓ Pertanyaan yang Sering Diajukan',
  practiceCTA: 'Mulai Latihan Sekarang',
  practiceCTADesc: 'Latihan Part {0} dalam kondisi seperti ujian nyata.',
  practiceStartTest: 'Mulai Simulasi {0}',
  practiceQuestions: 'soal',
  practicePartSelect: 'Pilih Part',

  roundsTitle: 'Set Simulasi Tes',
  roundLabel: 'Simulasi TOEFL',
  roundUnit: '',
  comingSoon: 'Segera Hadir',

  testPrevious: 'Sebelumnya',
  testNext: 'Selanjutnya',
  testQuestion: 'Soal',
  testQuestionPrompt: 'Lihat soal dan pilih jawaban yang tepat.',
  testMarkAnswer: 'Pilih jawaban yang benar.',
  testSelect: 'Pilih',
  testShowAnswer: 'Lihat Jawaban & Penjelasan',
  testCorrect: 'Benar!',
  testIncorrect: 'Salah.',
  testLoginPrompt: 'Catatan salah & lanjutkan memerlukan login.',
  testGoogleLogin: 'Mulai dengan Google dalam 3 detik',
  roundSelect: 'Pilih set lain',
  testAnswered: 'Terjawab',
  testSubmit: 'Kirim Tes',
  testSubmitTitle: 'Kirim tes {0}?',
  testSubmitDesc: 'Terjawab {1} dari {0} soal.',
  testUnanswered: '{0} soal belum dijawab.',
  testCannotUndo: 'Tindakan ini tidak dapat dibatalkan.',
  testContinue: 'Lanjutkan',
  testSubmitBtn: 'Kirim',

  resultsTitle: 'Hasil Tes {0}',
  resultsTimeUsed: 'Waktu: {0} menit {1} detik',
  resultsEstimatedScore: 'Perkiraan Skor (maks 30)',
  resultsCorrect: 'Benar',
  resultsIncorrect: 'Salah',
  resultsAccuracy: 'Akurasi',
  resultsReview: 'Review Jawaban',
  resultsYourAnswer: 'Jawaban Anda: {0}',
  resultsCorrectAnswer: 'Jawaban benar: {0}',
  resultsNoAnswer: 'Tidak dijawab',
  resultsHome: 'Beranda',
  resultsWrongNotes: 'Catatan Salah',
  resultsRetry: 'Coba Lagi',
  resultsShare: 'Bagikan Hasil',
  resultsShareText: 'Perkiraan skor TOEFL {0} saya adalah {1}! ({2}/{3} benar, akurasi {4}%) Coba gratis di Power TOEFL!',
  resultsShareCopied: 'Hasil disalin ke clipboard!',
  resultsNoResults: 'Tidak ada hasil tes.',
  resultsGoHome: 'Ke Beranda',
  resultsSaved: '{0} jawaban salah disimpan ke catatan',

  wrongAnswersTitle: 'Catatan Salah',
  wrongAnswersSaved: 'Soal Tersimpan',
  wrongAnswersHome: 'Beranda',
  wrongAnswersPracticeAll: 'Latihan Semua',
  wrongAnswersAll: 'Semua',
  wrongAnswersNoItems: 'Belum ada jawaban salah. Ikuti tes dulu!',
  wrongAnswersYourAnswer: 'Jawaban Anda: {0}',
  wrongAnswersCorrectIs: 'Jawaban benar: {0}',
  wrongAnswersReviewed: 'Sudah Direview',
  wrongAnswersRemoved: 'Dihapus dari catatan salah',
  wrongAnswersPracticeMode: 'Mode Latihan',
  wrongAnswersCorrectMsg: 'Benar!',
  wrongAnswersIncorrectMsg: 'Salah. Jawaban benar: {0}',
  wrongAnswersNextQuestion: 'Soal Berikutnya',
  wrongAnswersFinish: 'Selesai',
  wrongAnswersExitPractice: 'Keluar Latihan',
  wrongAnswersPracticeComplete: 'Latihan Selesai!',
  wrongAnswersNoPractice: 'Tidak ada soal untuk dilatih',
  wrongAnswersLimitNotice: 'Hanya menampilkan 500 jawaban salah terbaru.',

  privacyPageTitle: 'Kebijakan Privasi — Power TOEFL',
  privacyPageDesc: 'Kebijakan privasi Power TOEFL.',
  privacyHeading: 'Kebijakan Privasi',
  privacyLastUpdated: 'Terakhir diperbarui: 29 Maret 2026',
  privacyS1Title: '1. Informasi yang Dikumpulkan',
  privacyS1Body: 'Power TOEFL mengumpulkan email, nama, dan foto profil saat login Google. Informasi pembayaran diproses melalui Dodo Payments/PayPal.',
  privacyS2Title: '2. Tujuan Penggunaan',
  privacyS2Body: 'Data digunakan untuk catatan salah, manajemen progres belajar, langganan, dan peningkatan layanan.',
  privacyS3Title: '3. Penyimpanan dan Penghapusan',
  privacyS3Body: 'Data dihapus saat akun ditutup. Catatan pembayaran disimpan hingga 5 tahun sesuai hukum pajak.',
  privacyS4Title: '4. Pembagian ke Pihak Ketiga',
  privacyS4Body: 'Hanya email yang dibagikan ke Dodo Payments/PayPal untuk pemrosesan pembayaran.',
  privacyS5Title: '5. Cookie dan Iklan',
  privacyS5Body: 'Situs ini menggunakan Google AdSense dan cookie terkait. Pengaturan cookie dapat dikelola di browser.',
  privacyS6Title: '6. Transfer Data Internasional',
  privacyS6Body: 'Data dapat ditransfer secara internasional melalui server asing dengan perlindungan keamanan yang memadai.',
  privacyS7Title: '7. Hak Pengguna',
  privacyS7Body: 'Pengguna dapat meminta akses, koreksi, atau penghapusan data kapan saja.',
  privacyS8Title: '8. Kontak',
  privacyS8Body: 'Hubungi: skdaks0731@gmail.com',

  termsPageTitle: 'Ketentuan Layanan — Power TOEFL',
  termsPageDesc: 'Ketentuan layanan Power TOEFL.',
  termsHeading: 'Ketentuan Layanan',
  termsLastUpdated: 'Terakhir diperbarui: 29 Maret 2026',
  termsS1Title: '1. Gambaran Layanan',
  termsS1Body: 'Power TOEFL adalah platform belajar TOEFL online yang dioperasikan oleh ddookddak (nama badan usaha resmi kami), dengan fitur gratis dan premium (Pro/Lifetime).',
  termsS2Title: '2. Syarat Penggunaan',
  termsS2Body: 'Layanan tersedia untuk pengguna berusia 14 tahun ke atas. Beberapa fitur memerlukan login Google.',
  termsS3Title: '3. Hak Kekayaan Intelektual',
  termsS3Body: 'Konten situs (soal, desain, kode) milik Power TOEFL. TOEFL adalah merek dagang ETS.',
  termsS4Title: '4. Pembayaran',
  termsS4Body: 'Langganan premium diproses melalui Dodo Payments/PayPal. Harga mungkin termasuk PPN.',
  termsS5Title: '5. Disclaimer',
  termsS5Body: 'Skor simulasi bersifat perkiraan dan tidak menjamin hasil ujian TOEFL sebenarnya.',
  termsS6Title: '6. Tindakan Terlarang',
  termsS6Body: 'Dilarang menyalin/mendistribusikan soal, membebani sistem, atau berbagi akun.',
  termsS7Title: '7. Perubahan Layanan',
  termsS7Body: 'Layanan dapat diubah atau dihentikan tanpa pemberitahuan sebelumnya.',
  termsS8Title: '8. Pembatalan Langganan',
  termsS8Body: 'Langganan dapat dibatalkan kapan saja. Fitur premium tetap aktif hingga periode berakhir.',
  termsS9Title: '9. Perubahan Ketentuan',
  termsS9Body: 'Ketentuan dapat berubah dan akan diumumkan di situs. Penggunaan berkelanjutan dianggap persetujuan.',

  refundPageTitle: 'Kebijakan Pengembalian — Power TOEFL',
  refundPageDesc: 'Kebijakan pengembalian langganan premium Power TOEFL.',
  refundHeading: 'Kebijakan Pengembalian',
  refundLastUpdated: 'Terakhir diperbarui: 15 April 2026',
  refundS1Title: '1. Prinsip refund',
  refundS1Body: 'Karena sifat produk digital, pada prinsipnya refund tidak tersedia.',
  refundS2Title: '2. Kasus refund pengecualian',
  refundS2Body: 'Namun refund dapat diberikan secara pengecualian jika diwajibkan hukum, terjadi pembayaran ganda, layanan tidak diberikan, atau terjadi gangguan teknis besar.',
  refundS3Title: '3. Cara menghubungi',
  refundS3Body: 'Untuk pertanyaan terkait refund, gunakan kanal dukungan/masukan. Kontak: skdaks0731@gmail.com',
  refundS4Title: '4. Pembatalan langganan',
  refundS4Body: 'Langganan berbayar dapat dibatalkan kapan saja. Setelah pembatalan, akses premium tetap aktif hingga akhir periode tagihan saat ini dan tidak ada tagihan lanjutan.',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  footerPrivacy: 'Privasi',
  footerTerms: 'Ketentuan',
  footerRefund: 'Pengembalian',
  footerAbout: 'Tentang Kami',
  footerGuide: 'Panduan Belajar',
  guideLabel: 'Panduan Belajar',
  guideDesc: 'Strategi per skill, per skor, dan perbandingan ujian',

  aboutPageTitle: 'Latihan Soal TOEFL Gratis + Analisis AI — Tentang Power TOEFL',
  aboutPageDesc: 'Simulasi 4 bagian format 2026, analisis kelemahan AI, catatan salah otomatis — semuanya gratis.',
  aboutHeading: 'Power TOEFL — Platform Latihan TOEFL Online Terlengkap',
  aboutS1Title: 'Apa itu Power TOEFL?',
  aboutS1Body: 'Power TOEFL adalah platform latihan soal TOEFL online gratis dengan simulasi 4 bagian format 2026, AI pembuat soal, dan catatan salah otomatis.',
  aboutS2Title: 'Untuk Siapa?',
  aboutS2Body: 'Mahasiswa, profesional, pencari kerja internasional, dan semua pelajar TOEFL mandiri.',
  aboutS3Title: 'Fitur Utama',
  aboutFeature1: 'Simulasi Reading·Listening·Speaking·Writing format 2026 (multi set)',
  aboutFeature2: 'Latihan per Reading·Listening·Speaking·Writing',
  aboutFeature3: 'AI soal khusus & analisis kelemahan',
  aboutFeature4: 'Catatan salah otomatis + review Ebbinghaus',
  aboutFeature5: 'Tabel konversi skor & kosakata TOEFL',
  aboutS4Title: 'Gratis vs Premium',
  aboutS4Body: 'Gratis: simulasi, latihan, tabel skor. Premium: AI tak terbatas, tanpa iklan, akses semua set.',
  aboutS5Title: 'Mengapa Efektif?',
  aboutS5Body: 'Review cerdas Ebbinghaus, analisis kelemahan AI per bagian, dan simulasi format 2026.',
  aboutS6Title: 'Hubungan dengan ETS',
  aboutS6Body: 'Power TOEFL tidak berafiliasi dengan ETS. TOEFL® adalah merek dagang terdaftar ETS.',
  aboutS7Title: 'Kontak',
  aboutS7Body: 'Email: skdaks0731@gmail.com',
  aboutCtaHeading: 'Mulai Sekarang',
  aboutCtaDesc: 'Coba latihan soal simulasi TOEFL gratis.',
  aboutCtaStart: 'Mulai simulasi',
  aboutCtaPricing: 'Lihat Paket Premium',

  resumeTest: 'Lanjutkan',
  resumeDesc: '{0} Set {1} — {2}/{3} soal',
  progressLabel: 'Progres',
  timerLabel: 'Sisa waktu',
  timeUp: 'Waktu habis!',

  navHome: 'Beranda',
  navSettings: 'Tips',

  grammarSectionTitle: 'Buku Grammar',
  grammarSectionDesc: 'Pelajari grammar TOEFL secara sistematis',
  grammarViewAll: 'Lihat Semua',
  grammarChapter: 'Bab',

  aiPracticeTitle: 'AI Pembuat Soal TOEFL — Pilih Part & Level, Soal Baru Setiap Hari | Power TOEFL',
  aiPracticeDesc: 'Pilih Part dan level kesulitan, AI langsung buatkan soal TOEFL baru. Latihan tanpa batas setiap hari.',
  aiPracticeH1: '✨ AI Pembuat Soal TOEFL',
  aiPracticeSub: 'AI membuat soal TOEFL sesuai level Anda secara real-time.',
  aiPartLabel: 'Part',
  aiDiffLabel: 'Level',
  aiBeginner: 'Pemula (1.0–2.5)',
  aiIntermediate: 'Menengah (3.0–4.5)',
  aiAdvanced: 'Lanjutan (5.0–6.0)',
  aiGenerate: 'Buat Soal',
  aiGenerating: 'Membuat...',
  aiRemainingToday: 'Sisa {0} bulan ini',
  aiLimitReached: 'Credit AI bulan ini habis',
  aiLimitUpgrade: 'Beli credit tambahan atau upgrade paket!',
  aiUpgrade: 'Upgrade',
  aiListenPrompt: '🔊 Soal LC dengarkan audio sambil menjawab',
  aiPlayAudio: 'Putar Audio',
  aiStopAudio: 'Stop',
  aiCorrect: '✅ Benar!',
  aiWrong: '❌ Salah.',
  aiCorrectAnswer: 'Jawaban benar: {0}',
  aiPrev: 'Sebelumnya',
  aiNext: 'Selanjutnya',
  aiNewQuestions: 'Soal Baru',
  aiEmptyTitle: 'Buat soal dengan AI',
  aiEmptyDesc: 'Pilih part dan level, lalu klik "Buat Soal".',
  aiLoadingMain: 'AI sedang membuat dan memvalidasi soal...',
  aiLoadingSub: 'Sekitar 10~20 detik',

  statsTitle: 'Statistik Belajar — Power TOEFL',
  statsDesc: 'Statistik akurasi quiz grammar, review catatan salah dalam satu tampilan.',
  statsH1: '📊 Statistik Belajar',
  statsLoginPrompt: 'Login untuk melihat statistik belajar.',
  statsTotalQuizzes: 'Total Quiz',
  statsTotalQuestions: 'Total Soal',
  statsAccuracy: 'Akurasi',
  statsLast7Days: '7 Hari Terakhir',
  statsWrongSummary: 'Status Catatan Salah',
  statsViewAll: 'Lihat Catatan Salah',
  statsTotalWrong: 'Total Salah',
  statsReviewed: 'Sudah Review',
  statsPending: 'Belum Review',
  statsTopicAccuracy: 'Akurasi per Topik Grammar',
  statsAttempts: '{0} kali',
  statsEmpty: 'Belum ada riwayat belajar. Coba quiz grammar!',
  statsStartGrammar: 'Mulai Belajar Grammar',

  pricingTitle: 'Gratis Kurang? — Power TOEFL Pro (Rp169.000/bulan) | Belajar TOEFL 2x Lebih Cepat',
  pricingDesc: 'Gratis latihan harian. Pro: AI tanpa batas, tanpa iklan, semua set soal.',

  testLCTitle: 'Latihan TOEFL Reading gratis — Academic passages | 2026',
  testLCDesc: 'Latihan TOEFL Reading format 2026 gratis. Academic passages, catatan salah otomatis.',
  testRCTitle: 'Latihan TOEFL Listening gratis — Conversations·Lectures | 2026',
  testRCDesc: 'Latihan TOEFL Listening format 2026 gratis. Conversations dan Lectures dengan penjelasan AI.',

  reviewTitle: 'Review Hari Ini',
  reviewDesc: 'Sistem review cerdas berbasis kurva lupa Ebbinghaus',
  reviewSubtitle: 'Review pada waktu optimal berdasarkan kurva lupa',
  reviewRemaining: 'Sisa Review',
  reviewProgress: 'Progres Review',
  reviewCompleted: '🎉 Review Hari Ini Selesai!',
  reviewCompletedDesc: 'Sudah mereview {0} soal',
  reviewEmpty: 'Tidak ada soal untuk direview hari ini',
  reviewEmptyDesc: 'Semua review sudah selesai atau belum ada catatan salah.',
  reviewStage: 'Tahap {0}',
  reviewNextInterval: 'Interval {0} hari',
  reviewCorrect: 'Benar! Lanjut ke tahap berikutnya.',
  reviewWrong: 'Salah. Kembali ke tahap 1.',
  reviewNextReview: 'Review berikutnya: {0} hari lagi',
  reviewResetMsg: 'Salah, review lagi dalam 1 hari.',
  reviewNext: 'Soal Berikutnya',
  reviewFinish: 'Selesai',
  reviewHowItWorks: 'Prinsip Review Ebbinghaus',
  reviewDaysLater: '{0} hari kemudian',
  reviewExplanation: 'Soal salah direview dengan interval 1 → 3 → 7 → 14 → 30 → 60 hari. Benar = naik tahap, salah = kembali ke tahap 1.',

  notifTitle: 'Notifikasi',
  notifEmpty: 'Tidak ada notifikasi baru',
  notifMarkAllRead: 'Tandai sudah dibaca',
  timeJustNow: 'baru saja',
  timeMinutes: '{0} menit lalu',
  timeHours: '{0} jam lalu',
  timeDays: '{0} hari lalu',
  scoreCardEstimated: 'Perkiraan Skor',
  scoreCardCorrect: 'Benar',
  scoreCardIncorrect: 'Salah',
  scoreCardAccuracy: 'Akurasi',

  pushTitle: 'Aktifkan Notifikasi Belajar',
  pushDesc: 'Dapatkan pengingat review dan streak belajar.',
  pushEnable: 'Aktifkan',

  navReview: 'Review',
  navStats: 'Statistik',
  navPremium: 'Paket Pro',
  navSubscription: 'Kelola Langganan',
  roundDetailHeading: 'Simulasi TOEFL',
  roundDetailOtherRounds: 'Lihat set lain',
  roundSuffix: '',

  footer7DayPlan: 'Rencana 7 Hari',
  footerTrapPatterns: 'Pola Jebakan',

  pwaAddToHome: '📱 Tambah ke Layar Utama',
  pwaAddToHomeDesc: 'Jalankan seperti aplikasi! Belajar offline juga bisa',
  pwaInstall: 'Install',
  pwaIOSGuide: 'Bagikan → Tambah ke Layar Utama',

  aiQuizTitle: '🤖 Quiz AI',
  aiQuizDesc: 'Soal TOEFL Grammar buatan AI',
  aiQuizGenerateDesc: 'AI membuat 5 soal Grammar sesuai topik grammar secara real-time.',
  aiQuizGenerate: 'Buat Soal AI',
  aiQuizGenerating: '🤖 AI sedang membuat soal...',
  aiQuizGeneratingTime: 'Sekitar 5~10 detik',
  aiQuizNew: 'Soal Baru',
  aiQuizStats: 'Statistik:',
  aiQuizTimes: 'kali',
  aiQuizCheckAnswers: 'Cek Jawaban',
  aiQuizPerfect: '🎉 Semua Benar!',
  aiQuizCorrectCount: 'Benar',
  aiQuizSaving: 'Menyimpan hasil...',
  aiQuizTryNew: 'Coba Soal Baru',
  aiQuizError: 'Gagal membuat soal AI. Coba lagi.',

  tipsDetailStrategy: 'Strategi Detail',
  tips7DayTitle: '🗓️ Rencana Belajar 7 Hari Sebelum Ujian',
  tips7DayDesc: 'Maksimalkan skor dengan rutinitas akhir',
  tipsTrapTitle: '⚠️ Pola Jebakan Jawaban Salah',
  tipsTrapDesc: 'Kenali 5 pola jebakan yang sering menjebak',

  pricingSaveBadge: 'Hemat 30%',
  pricingPerMonth: '/bulan',
  pricingSSL: 'Pembayaran aman',
  pricingCurrentPlan: 'Paket saat ini',
  pricingFaqQ1: 'Apa bedanya Gratis dan Pro?',
  pricingFaqA1: 'Paket gratis menyediakan soal Reading·Listening dasar dan 1x AI/hari. Pro mencakup AI tanpa batas, feedback AI untuk Speaking·Writing, analisis 4 skill, dan tanpa iklan.',
  pricingFaqQ2: 'Bisa minta refund?',
  pricingFaqA2: 'Karena sifat produk digital, refund pada dasarnya tidak tersedia. Namun, refund dapat diberikan secara pengecualian jika diwajibkan hukum, terjadi pembayaran ganda, layanan tidak diberikan, atau terjadi gangguan teknis besar.',
  pricingFaqQ3: 'Bagaimana cara batal langganan?',
  pricingFaqA3: 'Anda bisa batal kapan saja di halaman Langganan Saya. Setelah batal, tetap bisa digunakan sampai masa berlaku habis.',
  pricingFaqQ4: 'Apa bedanya Lifetime dan Pro tahunan?',
  pricingFaqA4: 'Lifetime bayar sekali untuk selamanya. Pro tahunan perlu diperpanjang setiap tahun.',
  proBadgeLabel: 'Pro',
  pricingCard: 'Kartu kredit',
  pricingPaymentSuccess: 'Premium berhasil diaktifkan!',
  pricingPaymentCancelled: 'Pembayaran dibatalkan.',
  pricingLoginRequired: 'Login diperlukan.',
  pricingPaymentError: 'Gagal membuat pembayaran.',

  subLoginRequired: 'Login diperlukan.',

  grammarSystematic: 'Belajar Grammar Sistematis',
  grammarBookTitle: 'Buku Grammar TOEFL',
  grammarBookDesc: 'Pelajari 20 topik grammar TOEFL secara sistematis. Setiap bab dilengkapi contoh dan latihan.',
  grammarTestAfter: 'Tes setelah belajar grammar!',
  grammarTestAfterDesc: 'Lihat bagaimana grammar muncul di TOEFL asli',
  grammarMockTest: 'Simulasi Tes',
  grammarDoneTitle: 'Selesai belajar grammar?',
  grammarDoneDesc: 'Terapkan di simulasi tes. Jawaban salah otomatis tersimpan!',
  grammarStartRC: 'Mulai Simulasi RC',
  grammarPracticePart5: 'Latihan Grammar',
  grammarCourseName: 'Grammar TOEFL Lengkap',
  grammarBreadcrumb: 'Buku Grammar',

  grammarHome: 'Beranda',
  grammarExamples: 'Contoh Kalimat',
  grammarTestKnowledge: '📝 Uji Pemahaman',
  grammarTestKnowledgeDesc: 'Kerjakan soal terkait grammar yang baru dipelajari!',
  grammarCheckAnswers: 'Cek Jawaban',
  grammarPerfect: '🎉 Semua Benar!',
  grammarCorrectCount: 'Benar',
  grammarMockCTA: '🔥 Uji kemampuan di simulasi tes!',
  grammarMockCTADesc: 'RC 100 soal + catatan salah otomatis',
  grammarStartRCMock: 'Mulai Simulasi RC',
  grammarPractice5: 'Latihan Grammar',
  grammarTestInPractice: 'Cek di soal nyata!',
  grammarTestInPracticeDesc: 'Lihat bagaimana topik grammar muncul di TOEFL.',
  grammarRelated: '📚 Grammar Terkait',

  wrongAnswersGrammarAI: 'Grammar AI',

  streakDays: 'hari',
  streakLabel: 'Streak Belajar',
  streak7: 'Streak 1 minggu!',
  streak14: 'Streak 2 minggu!',
  streak30: 'Luar biasa! Streak 1 bulan!',
  reviewItems: '',
  reviewTodayLabel: 'Soal review hari ini',
  reviewGoLabel: '📚 Mulai Review →',

  leaderboardTitle: 'Peringkat Belajar',
  leaderboardWeekly: 'Mingguan',
  leaderboardMonthly: 'Bulanan',
  leaderboardLoading: 'Memuat...',
  loadingQuestions: 'Memuat soal...',
  leaderboardEmpty: 'Belum ada data {period} ini',
  leaderboardEmptyWeek: 'minggu',
  leaderboardEmptyMonth: 'bulan',
  leaderboardHint: 'Selesaikan tes untuk masuk peringkat!',
  leaderboardRank: 'Peringkat',
  leaderboardNickname: 'Nama',
  leaderboardSolved: 'Soal',
  leaderboardAccuracy: 'Akurasi',
  leaderboardMe: 'Saya',
  leaderboardMyRank: '🏅 Peringkat saya: #{rank}',

  tipsCoreTips: 'Tips Inti',
  tipsStrategy: 'Strategi Ujian',
  tipsCTA: 'Sudah paham strategi? Mulai latihan!',

  testScrollHint: 'Scroll untuk melihat soal dan pilihan',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: 'Dengarkan audio dan pilih jawaban',
  testPart3Label: 'Lectures',

  creditBuyBtn: 'Beli Kredit',
  creditBuyTitle: 'Beli Kredit AI',
  creditBuyDesc: 'Beli kredit tambahan untuk umpan balik AI Speaking/Writing dan latihan AI.',
  creditBuyError: 'Gagal memulai pembayaran',
  creditBuyNote: 'Pembayaran melalui PayPal. Kredit ditambahkan langsung setelah pembayaran.',
  creditUnit: 'kredit',

  speakingPageH1: 'Latihan TOEFL Speaking 2026',
  speakingPageSub: '{count}+ soal Speaking gratis — Listen and Repeat · Interview',
  speakingPageTitle: 'Latihan TOEFL Speaking 2026 — {count}+ soal gratis | Power TOEFL',
  speakingPageDesc: 'Latihan TOEFL Speaking {count}+. Contoh jawaban, rubrik penilaian, AI feedback. 2026.',
  speakingAllTasks: 'Semua',
  speakingNoPrompts: 'Belum ada soal Speaking',
  speakingNoPromptsSub: 'Soal sedang dibuat. Silakan cek lagi nanti!',
  speakingResponseTime: 'Waktu respons',

  writingPageH1: 'Latihan TOEFL Writing 2026',
  writingPageSub: '{count}+ tugas Writing gratis — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'Latihan TOEFL Writing 2026 — {count}+ tugas gratis | Power TOEFL',
  writingPageDesc: 'Latihan TOEFL Writing {count}+. Contoh jawaban, rubrik penilaian. 2026.',
  writingAllTasks: 'Semua',
  writingNoPrompts: 'Belum ada soal Writing',
  writingNoPromptsSub: 'Soal sedang dibuat. Silakan cek lagi nanti!',

  catPageTitle: 'TOEFL Adaptive Test (CAT) — AI atur tingkat kesulitan otomatis | Power TOEFL',
  catPageDesc: 'Ujian latihan TOEFL adaptif komputer. AI mengatur tingkat kesulitan berdasarkan akurasi.',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'Tingkat kesulitan menyesuaikan akurasi Anda. {count} soal per sesi.',
  catNote: "ℹ️ Catatan: TOEFL iBT yang sebenarnya adalah tes linear (non-adaptif). Practice CAT ini adalah alat belajar yang menyesuaikan tingkat kesulitan dengan performa Anda agar cepat menemukan level Anda — bukan simulasi format ujian sebenarnya.",
  catSelectSection: 'Pilih Bagian',
  catStartBtn: 'Mulai Adaptive Test',
  catLoading: 'Memuat soal berikutnya...',
  catNoMore: 'Tidak ada soal lagi',
  catComplete: 'Adaptive Test Selesai',
  catAccuracy: 'Akurasi',
  catFinalLevel: 'Level akhir',
  catTryAgain: 'Coba Lagi',
  catViewResults: 'Lihat Hasil',
  catNext: 'Berikutnya',
  catExplanation: 'Penjelasan',
  catStop: 'Berhenti',
  catPlayAudio: '🔊 Putar Audio',
  catReadingPassage: 'Reading Passage',

  scoreReadingHeader: 'Reading (0~30 poin)',
  scoreListeningHeader: 'Listening (0~30 poin)',
  scoreSpeakingHeader: 'Speaking (0~30 poin)',
  scoreWritingHeader: 'Writing (0~30 poin)',
  scoreSpeakingDesc: '4 tugas dinilai 0~4 lalu dikonversi ke 30 poin',
  scoreWritingDesc: '2 tugas dinilai 0~5 lalu dikonversi ke 30 poin',
  scoreSpeakingLevels: [
    ['4 poin (Good)', '27~30', 'Jawaban lancar dan akurat, logis'],
    ['3 poin (Fair)', '19~26', 'Cukup jelas tapi ada kesalahan'],
    ['2 poin (Limited)', '11~18', 'Komunikasi dasar tapi terbatas'],
    ['1 poin (Weak)', '1~10', 'Sulit menyampaikan makna'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5 poin (Good)', '27~30', 'Esai logis dan spesifik, tata bahasa akurat'],
    ['4 poin (Fair)', '22~26', 'Secara keseluruhan baik tapi ada kekurangan'],
    ['3 poin (Limited)', '15~21', 'Struktur dasar ada tapi kurang pengembangan'],
    ['2 poin (Weak)', '8~14', 'Keluar topik atau struktur tidak jelas'],
    ['1 poin (Very Weak)', '1~7', 'Hampir tidak bisa menyampaikan makna'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    'Perlu Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+. Bisa masuk universitas top.',
    'Target Reading 22+ / Listening 22+. Memenuhi standar sebagian besar universitas.',
    'Level bahasa Inggris akademik dasar. Penerimaan bersyarat. Perlu belajar intensif.',
    'Tahap dasar. Disarankan fokus Reading dan Listening.',
  ],
  // --- Flashcard mode ---
  vocabFlashcardStart: "Mulai Flashcard",
  vocabFlashcardStop: "Hentikan Flashcard",
  vocabFlashcardEmpty: "Tambahkan kata terlebih dahulu untuk memulai flashcard.",
  vocabFlashcardSpeed: "Kecepatan",
  vocabFlashcardSpeedSlow: "Lambat",
  vocabFlashcardSpeedNormal: "Normal",
  vocabFlashcardSpeedFast: "Cepat",
  vocabFlashcardShuffle: "Acak",
  vocabFlashcardPrev: "Sebelumnya",
  vocabFlashcardNext: "Berikutnya",
  vocabFlashcardFlip: "Balik",
  vocabFlashcardProgress: "{current} / {total}",
};

export default id;
